import HTMLReactParser from 'html-react-parser'

export const convertHTMLStringToDOM = (escapedHTML: string): JSX.Element => {
  const unescapedHtml = HTMLReactParser(escapedHTML)
  if (typeof unescapedHtml === 'string') {
    return HTMLReactParser(unescapedHtml as string) as JSX.Element
  }
  return unescapedHtml as JSX.Element
}
